import { useNavigate } from "react-router-dom"
import { StepProps } from "../../../../components/Stepper"
import { AuthData } from "../../../../types/steps/auth"
import { useState } from "react"
import { appStore } from "../../../../store/appStore"
import { userStore } from "../../../../store/userStore"
import MaskInput, { masks } from "../../../../features/auth/MaskInput"
import { useTimer } from "../../../../hooks/useTimer"
import { useAuth } from "../../../../hooks/useAuth"
import { applyPendingLocation } from "../../../../lib/locationSwitch"
import { clearAuthDraft } from "../../../../lib/authDraft"
import AuthSheetLayout, { AuthSheetButton } from "../../../../features/auth/AuthSheetLayout"
import { AuthCaption } from "../../../../features/auth/AuthShell"

export default function Code({ params, navigate, goBack }: StepProps<AuthData>) {
    const { phone, registered } = params
    const router = useNavigate()
    const { lastSmsCodeAt } = appStore()
    const [code, setCode] = useState("")
    const [loading, setLoading] = useState(false)
    const [resending, setResending] = useState(false)
    const { setUser } = userStore()
    const { remainSec } = useTimer(lastSmsCodeAt)
    const { sendCode, checkCode } = useAuth()
    const [error, setError] = useState(false)

    const isComplete = code.length >= masks.code.maxDigits

    const handleSubmitCode = async (submittedCode: string) => {
        try {
            setLoading(true)
            const user = await checkCode(submittedCode, registered!, phone!, setError)

            if (registered) {
                setUser(user)
                clearAuthDraft()
                applyPendingLocation()
                router(-1)
            } else {
                navigate("user", { phoneVerification: user.phone_verification, reauth: params.reauth })
            }
        } finally {
            setLoading(false)
        }
    }

    const handleResend = async () => {
        if (!phone || resending || remainSec) return
        try {
            setResending(true)
            await sendCode(phone, "sms")
            setCode("")
            setError(false)
        } finally {
            setResending(false)
        }
    }

    const footerButton = isComplete ? (
        <AuthSheetButton variant="primary" disabled={loading} onClick={() => handleSubmitCode(code)}>
            {loading ? "Проверка..." : "Далее"}
        </AuthSheetButton>
    ) : (
        <AuthSheetButton variant="primary" disabled={Boolean(remainSec) || resending} onClick={handleResend}>
            {resending
                ? "Отправка..."
                : remainSec
                  ? `Отправить код через ${remainSec} сек`
                  : "Отправить код повторно"}
        </AuthSheetButton>
    )

    return (
        <AuthSheetLayout title="Код из СМС" onBack={goBack} footer={footerButton}>
            <div className="flex flex-col items-center gap-6 py-4">
                <MaskInput digits={code} setDigits={setCode} type="code" error={error} setError={setError} centered autoFocus />
                <AuthCaption className="text-center">
                    Код отправлен на номер <span className="text-white">{`+7${phone}`}</span>
                </AuthCaption>
            </div>
        </AuthSheetLayout>
    )
}
